import { render, staticRenderFns } from "./ModelBasic.vue?vue&type=template&id=26efcb8a&scoped=true"
import script from "./ModelBasic.vue?vue&type=script&lang=js"
export * from "./ModelBasic.vue?vue&type=script&lang=js"
import style0 from "./ModelBasic.vue?vue&type=style&index=0&id=26efcb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26efcb8a",
  null
  
)

export default component.exports